<template>
  <div style="padding: 30px 30px 0 0">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="手机号" :required="true">
        <el-input :value="form.contactPhone" placeholder="手机号" />
      </el-form-item>
      <el-form-item label="验证码" prop="verificationCode">
        <el-row>
          <el-col :span="16">
            <el-input
              v-model="form.verificationCode"
              placeholder="请输入验证码"
            />
          </el-col>
          <el-col :span="7" :offset="1">
            <el-button
              type="primary"
              :disabled="isSmsBtnDisabled"
              @click="onSendSms"
            >{{ smsBtnTxt }}</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button @click="funcCancel">取 消</el-button>
        <el-button type="primary" @click="funcSubmit">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  bindPhoneSendSms,
  unbindPhoneSendSms,
  bindPhone,
  unbindPhone,
} from "@/api/merchantCenter";
export default {
  name: "BindPhone",
  data() {
    return {
      isSmsBtnDisabled: false,
      intervalTimer: 0,
      form: {
        verificationCode: "",
        contactPhone: "",
        merchantCode: "",
      },
      smsBtnTxt: "发送验证码",
      mode: "bind",
      rules: {
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    resetCountdown() {
      this.isSmsBtnDisabled = false;
      clearInterval(this.intervalTimer);
      this.smsBtnTxt = "发送验证码";
    },
    onSendSms() {
      this.isSmsBtnDisabled = true;
      // 倒计时 start
      const TIME_COUNT = 60;
      let count = TIME_COUNT;
      this.intervalTimer = setInterval(() => {
        if (count > 0 && count <= TIME_COUNT) {
          count--;
          this.smsBtnTxt = count + "s";
        } else {
          this.resetCountdown();
        }
      }, 1000);
      // 倒计时 finish
      let fn = null;
      switch (this.mode) {
        case "bind":
          fn = bindPhoneSendSms;
          break;
        case "unbind":
          fn = unbindPhoneSendSms;
          break;
      }
      fn(this.form)
        .then((res) => {
          if (res.status === 0) {
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
            this.resetCountdown();
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.resetCountdown();
        });
    },
    // 短信验证码
    setDetail(obj) {
      this.$refs["form"].resetFields();
      this.resetCountdown();
      this.form.contactPhone = obj.phone;
      this.form.merchantCode = obj.code;
      this.mode = obj.mode;
    },
    // 取消
    funcCancel() {
      this.$emit("hideBindPhoneModel", false);
    },
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          let fn = null;
          switch (this.mode) {
            case "bind":
              fn = bindPhone;
              break;
            case "unbind":
              fn = unbindPhone;
              break;
          }
          fn(this.form)
            .then((res) => {
              rLoading.close();
              if (res.status === 0) {
                this.$message.success(res.msg);
                this.$emit("hideBindPhoneModel", true);
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              rLoading.close();
              this.$message.error(err);
            });
        }
      });
    },
  },
};
</script>
